export default "__VITE_ASSET__BSYKJOVR__"